import cx from 'clsx';
import type { HTMLProps, ReactNode } from 'react';
import styles from './placeholder.module.css';

export interface PlaceholderProps extends HTMLProps<HTMLSpanElement> {
  width?: string;
  height?: string;
}

export function Placeholder({
  className,
  style = {},
  width = '100%',
  height = '10px',
  ...rest
}: PlaceholderProps): ReactNode {
  const mergedStyle = { ...style, width, height };

  return (
    <span
      className={cx(styles.placeholder, className)}
      data-testid="pdf-preview-placeholder"
      style={mergedStyle}
      {...rest}
    />
  );
}
